import styled from 'styled-components';

export const AssignCell = styled.div`
  display: flex;
  align-items: center;
  gap: 5px;
  overflow: visible !important;

  svg {
    cursor: pointer;

    :hover {
      color: var(--color-accent);
    }
  }

  .assignee {
    text-overflow: ellipsis;
    overflow: hidden;
    width: 140px;

    .assignName {
      font-style: normal;
      font-weight: 400;
      font-size: 16px;
      line-height: 130%;
      margin: 10px 0 0;
      text-decoration: underline;
    }

    .assignEmail {
      font-style: normal;
      font-weight: 500;
      font-size: 10px;
      line-height: 160%;
      align-items: center;
      justify-content: center;
      margin: 0 0 10px;
      text-decoration: none;
    }
  }
`;
